import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHashtag16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconHashtag16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.21 2.07a.5.5 0 1 0-.99-.14L5.765 5.1H2.857a.5.5 0 1 0 0 1h2.766l-.542 3.8H2a.5.5 0 0 0 0 1h2.938l-.433 3.03a.5.5 0 1 0 .99.14l.453-3.17h3.275l-.432 3.03a.5.5 0 0 0 .99.14l.453-3.17h2.909a.5.5 0 1 0 0-1h-2.767l.543-3.8H14a.5.5 0 0 0 0-1h-2.938l.433-3.03a.5.5 0 1 0-.99-.14l-.453 3.17H6.777zM6.633 6.1 6.09 9.9h3.275l.543-3.8z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHashtag16);
